<!-- Angular template: dashboard.component.html -->
<canvas #confettiCanvas class="dashboard-confetti-canvas"></canvas>

<div class="dashboard-container">
  <div class="container-item">
    <div class="next-event">
      <div class="event-item">
        <h3>My next event</h3>

        <div *ngIf="nextEvents.length > 0">
          <div
            class="event-container"
            *ngFor="let row of nextEvents; let i = index"
            (click)="onView(row)"
          >
            <div class="d-flex justify-content-end">
              <!-- <span class="status-box" *ngIf="row?.eventImages.length > 1">{{row?.status}}</span> -->
            </div>
            <div class="event-images">
              <div class="event-images-container">
                <img
                  *ngIf="getEventImage(row)"
                  [src]="getEventImage(row)"
                  alt=""
                />
                <span
                  *ngIf="row?.eventStatus"
                  [ngClass]="{
                    'event-status-on-today': row?.eventStatus?.toLowerCase() === 'on today',
                    'event-status-upcoming': row?.eventStatus?.toLowerCase() === 'upcoming'
                  }"
                >{{ row?.eventStatus }}</span>
              </div>
            </div>

            <div class="event-details">
              <h3>{{ row?.eventName }}</h3>
              <h5>{{ row?.eventType }}</h5>

              <div class="event-details-list">
                <div class="w-100 d-flex gap-4">
                  <div class="d-grid gap-0">
                    <div class="date-text">Start date</div>
                    <p class="value-text">
                      {{ row?.eventStartDate | brisbaneDate: "dd-MM-yyyy" }}
                    </p>
                  </div>
                  <div>
                    <div class="date-text">End date</div>
                    <p class="value-text">
                      {{ row?.eventEndDate | brisbaneDate: "dd-MM-yyyy" }}
                    </p>
                  </div>
                </div>
                <div *ngIf="row?.eventTime">
                  <div class="date-text">Time</div>
                  <p class="value-text">{{ row?.eventTime }}</p>
                </div>
                <div>
                  <div class="date-text">Location</div>
                  <p class="value-text">{{ row?.location }}</p>
                </div>
              </div>
            </div>

            <button
              class="event-register"
              [ngClass]="row?.statusClass"
              (click)="onView(row)"
            >
              {{ row?.status || "Interested" }}
            </button>
          </div>
        </div>

        <div class="event-item-dummy" *ngIf="nextEvents.length === 0">
          <div>No upcoming events</div>
        </div>
      </div>

      <div class="event-faq" (click)="openFaqDialog()">
        <div>
          <img src="assets/icons/side-bar/info-icon.svg" alt="" />
        </div>
        <h2>FAQ</h2>
      </div>
    </div>

    <div class="banner-container">
      <div class="top-container">
        <h4>{{ today | brisbaneDate: "d MMMM y" }}</h4>
        <div>
          <h2>Welcome back, <br />{{ user.name }}!</h2>
          <!-- <h5>Always stay update in your student portal</h5> -->
        </div>
      </div>

      <div class="bottom-container">
        <a
          href="https://constructionpathways.com.au/careers-quiz/"
          target="_blank"
          rel="noopener noreferrer"
          style="background-color: #faa633"
        >
          <img
            src="/assets/animations/CPxTREX_panel-2.png"
            alt=""
            style="cursor: pointer"
          />
        </a>

        <a
          href="https://year13.com.au/academy/tools-of-the-trade/introduction-to-construction"
          target="_blank"
          style="background-color: #b35d9d"
          rel="noopener noreferrer"
        >
          <img src="/assets/animations/CPxTREX_panel-3.png" alt="" />
        </a>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <h2 class="upcoming-event-text">My Activities</h2>
        <app-button
          label="Submit work experience"
          [minWidth]="'15.813rem'"
          (clicked)="openExternalEventDialog()"
        ></app-button>
      </div>

      <div class="upcoming-event">
        <!-- <div class="segment-buttons">
          <button [disabled]="selectedSegment === 'admin'" [class.active]="selectedSegment === 'admin'"
            (click)="switchSegment('admin')">
            CSQ events
          </button>
          <button [disabled]="selectedSegment === 'teacher'"
            [class.active]="selectedSegment === 'teacher'" (click)="switchSegment('teacher')">
            Teacher-created work experience
          </button>
          <button [disabled]="selectedSegment === 'student'"
            [class.active]="selectedSegment === 'student'" (click)="switchSegment('student')">
            Student-submitted work experience
          </button>
        </div> -->

        <div>
          <!-- <app-table 
          [columns]="selectedSegment === 'teacher' ? secondarColumns : columns" 
          [data]="rows" [actionTemplate]="actionTpl" [loading]="loading" 
          > -->
          <app-table
            [columns]="columns"
            [data]="rows"
            [actionTemplate]="actionTpl"
            [loading]="loading"
            (rowClick)="onView($event)"
          >
            <!-- (statusClick)="onStatusClick($event)" -->
          </app-table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #actionTpl let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      (click)="onView(row)"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
    <img
      *ngIf="row.source === 'Student' && row.status !== 'Approved'"
      class="action-button"
      (click)="onEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="Edit"
    />
  </div>
</ng-template>
